
import { authMedia } from '../firebase/firebase-app-media';
// import { listenToPictures } from './pictures';

export const listenToAuthMedia = () => {
	return (dispatch, getState) => {
		authMedia.onAuthStateChanged((authData) => {
			if (authData) {
				dispatch({
					type: 'AUTH_MEDIA_LOGIN',
					uid: authData.uid,
					username: authData.displayName
				});
				//here listen to some data from firebase
        // dispatch(listenToPictures());
			} else {
				if (getState().auth.status !== 'AUTH_MEDIA_ANONYMOUS') {
					dispatch({ type: 'AUTH_MEDIA_LOGOUT' });
				}
			}
		});
	};
};

export const openAuthMedia = () => {
	return (dispatch) => {
		dispatch({ type: 'AUTH_MEDIA_OPEN' });
		authMedia.signInAnonymously()
			.catch(function(error) {
	    		dispatch({
						type: 'AUTH_MEDIA_DISPLAY_ERROR',
						error: `Login failed! ${error}`
					});
					dispatch({ type: 'AUTH_MEDIA_LOGOUT' });
			});
	};
};

export const logoutUserMedia = () => {
	return (dispatch) => {
		dispatch({ type: 'AUTH_MEDIA_LOGOUT' });
		authMedia.signOut();
	};
};



// WEBPACK FOOTER //
// ./src/actions/auth-media.js